<script>
import PoolPrizeComp from "@/components/2025/Partials/PoolPrizeComp.vue"
import PlayModeComp from "@/components/2025/Partials/PlayModeComp.vue"

export default {
  name: 'TournamentCard.vue',
  components: {
    PoolPrizeComp,
    PlayModeComp
  },
  props: ["tournament"],
  data() {
    return {
      isHover: false,
      isMobile: false,
    };
  },
  computed:{
    isMobileDevice() {
      const ua = navigator.userAgent || navigator.vendor || window.opera
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
    }
  },
  methods: {
    handleSize(){
      if(window.innerWidth < 575){
        this.isMobile = true;
      }else{
        this.isMobile = false;
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleSize);
  }
};
</script>

<template>
  <div class="wrapper p-0" @mouseover="isHover = true" @mouseleave="isHover = false">
    <div class="tournament-card d-flex align-items-end position-relative h-100 w-100" :style="{backgroundImage: `url(${tournament.bg})`}">
      <div class="card-hover-layer position-absolute h-100 w-100" :class="{'invisible': !isHover }" v-if="!isMobileDevice">
        <div class="arrow-icon-container w-100 h-100 d-flex justify-content-end p-2">
          <img class="" :src="require('@/assets/imgs/2025/icons/arrow-up-right.png')" alt="arrow-icon" height="36px"/>
        </div>
      </div>
      <div class="tournament-infos d-flex flex-column align-items-start justify-content-end flex-lg-row justify-content-lg-between align-items-lg-end w-100 h-100 text-white position-absolute h-100 w-100 p-3">
        <div class="w-50">
          <h4 class="tournament-title text-uppercase text-wrap m-0">{{tournament.title}}</h4>
        </div>
        <div class="d-flex justify-content-between align-items-center w-50 mt-3 mt-lg-0">
          <div class="">
            <PoolPrizeComp :prize="tournament.poolPrize"></PoolPrizeComp>
          </div>
          <div class="ml-5 mx-lg-0">
            <PlayModeComp :playMode="tournament.playMode"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.wrapper:hover{
  cursor: pointer;
  transform: scale(1.002);
}
.tournament-card{
  min-height: 340px;
  border-radius: 18px 4px 18px 4px;
  clip-path: polygon(16px 0, 100% 0, 100% calc(100% - 16px), calc(100% - 16px) 100%, 0 100%, 0 16px);
  background: var(--forground-bg-color);
  background-size: cover;
  background-repeat: no-repeat;
}
.tournament-infos{
  top: 0;
  left: 0;
  z-index:2;
  background: transparent;
}
.card-hover-layer{
  top: 0;
  left:0;
  z-index: 1;
  background: rgba(250, 70, 36, 0.34);
  background: linear-gradient(0deg,rgba(250, 70, 36, 0.8) 0%, rgba(250, 70, 36, 0.3) 20%, rgba(250, 70, 36, 0.1) 50%, rgba(250, 70, 36, 0) 100%);
}
.tournament-title{
  font-family: "sqwaredbold";
}
</style>
